import React from 'react';
import { Typography } from '@mui/material';
import { DateTime } from 'luxon';

type FormatTableDateProps = {
  date: Date | undefined;
};

export function FormatTableDate({ date }: FormatTableDateProps) {
  let dateString = '-';
  if (date) {
    dateString = DateTime.fromISO(new Date(date).toISOString()).toFormat(
      'dd-MM-yyyy hh:mm a',
    );
  }
  return <Typography variant="body2">{dateString}</Typography>;
}
